var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-header",class:_vm.headerClasses,attrs:{"data-cy":_vm.dataCy}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }